<template>
  <vetster-button
    :variant="variant"
    size="fixed"
    :class="buttonClass"
    class="mt-6 w-full md:w-auto"
    @click="submit"
  >
    {{ getButtonText }}
  </vetster-button>
</template>

<script>
import { mapGetters } from 'vuex';

import { getAppUrl } from '@/helpers/url';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';
import ParseErrors from '@/mixins/ParseErrors';

export default {
  name: 'VetsterMembershipOfferingButton',

  mixins: [
    LocalizesRoutes,
    ParseErrors,
  ],

  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: null,
    },
    buttonUrl: {
      type: String,
      default: null,
    },
    isPayAsYouGo: {
      type: Boolean,
      default: true,
    },
    promoCode: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: 'bubblegum',
    },
  },

  computed: {
    ...mapGetters(['getUser']),
    ...mapGetters('subscriptionPlans', ['getYearlySubscriptionPlan']),
    getButtonText() {
      if (this.buttonText) {
        return this.buttonText;
      }

      return this.isPayAsYouGo ? this.$t('membership-subscriptions.talk-to-a-vet') : this.$t('membership-subscriptions.select-plan');
    },
    membershipType() {
      return this.isPayAsYouGo ? 'payasyougo' : 'yy';
    },
    plan() {
      return this.getYearlySubscriptionPlan ?? {};
    },
  },

  methods: {
    submit() {
      this.$analytics.track({
        eventName: `select_membership_${this.membershipType}`,
        user_uuid: this.getUser?.uuid,
        parent: 'membership-landing-page',
        child: 'homepage',
        code: this.promoCode,
      });

      if (this.buttonUrl) {
        return window.open(this.buttonUrl);
      }

      const params = {};
      if (this.promoCode) {
        params.code = this.promoCode;
      }

      if (this.isPayAsYouGo) {
        if (params.code) {
          return window.open(`${this.guidedSearchUrl}?${new URLSearchParams(params).toString()}`);
        }

        return window.open(this.guidedSearchUrl);
      }

      return window.open(getAppUrl(`/cx/subscription/checkout/${this.plan.uuid}`, params), '_self');
    },
  },
};
</script>
